import { Button, Flex, Select } from '@gmg/gmg-react-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Options } from '../SelectElementWrapper';

export interface AssignSitesToOrgModalProps {
    siteOptions: Array<Options>;
    selectedSites: Array<Options>;
    onSelectionChange: (selected: Array<Options>) => void;
    onSave: () => void;
    onClose?: () => void;
    isSaveDisabled: boolean;
}

const AssignSitesToOrgModal: FC<AssignSitesToOrgModalProps> = (props) => {
    const { t } = useTranslation();

    return (
        <Container aria-label='Container-Assign'>
            <ContentSection>
                <SelectorTitle>
                    {t('AssignSitesToOrgModal.section_title', 'Sites')}
                </SelectorTitle>
                <span className="px10_400_normal">
                    {t('AssignSitesToOrgModal.section_desc', 'Select the organizations that should be assigned as sites of this organization. Select the organizations that should be assigned as sites of this organization. Assigning a site automatically makes this organization a Head Organization.')}
                </span>
                <Select
                    width="100%"
                    name="Sites Selector"
                    placeholder={t('Common.combo_placeholder', 'Please select')}
                    options={props.siteOptions}
                    value={props.selectedSites}
                    onChange={(value) => props.onSelectionChange((value as Array<Options>) ?? [])}
                    isMulti
                    isSearchable
                    maxMenuHeight={200}
                />
            </ContentSection>

            <ButtonContainer>
                <Button
                    variant="primary"
                    type="button"
                    onClick={props.onSave}
                    disabled={props.isSaveDisabled}
                >
                    {t('ButtonTitles.action_save_btn', 'Save')}
                </Button>
                <Button
                    variant="secondary"
                    type="button"
                    onClick={props.onClose}
                >
                    {t('ButtonTitles.action_cancel_btn', 'Cancel')}
                </Button>
            </ButtonContainer>
        </Container>
    );
};

const Container = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    overflow: visible;
    min-height: 368px;
`;

const ContentSection = styled(Flex)`
    flex-direction: column;
    gap: 8px;
    padding: 8px;
`;

const SelectorTitle = styled.span`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.textNormal};
    margin-bottom: 8px;
`;

const ButtonContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;
    padding-right: 8px;
    padding-bottom: 8px;
    padding-top: auto;
    gap: 16px;
`;

export default AssignSitesToOrgModal;
